import { render, staticRenderFns } from "./manualWork.vue?vue&type=template&id=3c54403d"
import script from "./manualWork.vue?vue&type=script&lang=ts"
export * from "./manualWork.vue?vue&type=script&lang=ts"
import style0 from "./manualWork.vue?vue&type=style&index=0&id=3c54403d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports